import React from 'react';
import Header from '../../components/Layout/Header';
import './Department.css';

const Admin: React.FC = () => {
  return (
    <div className="department-page">
      <Header />
      <div className="department-container">
        <div className="department-header">
          <h1>Administration Department</h1>
          <p className="department-description">
            Welcome to the Administration Department page. Here you can find administrative 
            information, policies, and operational resources.
          </p>
        </div>
        <div className="department-content">
          <div className="department-card">
            <h3>About Administration Department</h3>
            <p>
              The Administration Department is responsible for managing day-to-day operations, 
              administrative processes, facilities management, and ensuring smooth organizational operations.
            </p>
          </div>
          <div className="department-card">
            <h3>Key Functions</h3>
            <ul>
              <li>Administrative Operations</li>
              <li>Facilities Management</li>
              <li>Policy Implementation</li>
              <li>Document Management</li>
              <li>Office Administration</li>
              <li>Compliance Management</li>
            </ul>
          </div>
          <div className="department-card">
            <h3>Contact Information</h3>
            <p>For administrative inquiries, please contact the Administration Department.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admin;

